import { render, staticRenderFns } from "./group_table.vue?vue&type=template&id=27aa1779&scoped=true&"
import script from "./group_table.vue?vue&type=script&lang=js&"
export * from "./group_table.vue?vue&type=script&lang=js&"
import style0 from "./group_table.vue?vue&type=style&index=0&id=27aa1779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa1779",
  null
  
)

export default component.exports